<ngx-exdr-stmx-common-loader></ngx-exdr-stmx-common-loader>
<input type="hidden" id="faviconUrl" [value]="faviconUrl()">
<router-outlet></router-outlet>